import getComponent from '../utils/get-component'

export default getComponent('bg-dark-gray w5 pv2')
